import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';
import {Route, NavigationGuardNext} from 'vue-router';
import {LiquidationRouteNames} from './constants/routeNames';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

export default [
  {
    path: '/clientdashboard/liquidate-account',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/layouts/authenticated/Index.vue'),
    meta: {
      useLayouts: true,
    },
    children: [
      {
        path: '',
        name: LiquidationRouteNames.LiquidationLandingPage,
        props: true,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/liquidation/LiquidationLandingPage.vue'),
        meta: {
          useLayouts: true,
        },
      },
      {
        path: 'source',
        name: LiquidationRouteNames.LiquidationSourcePage,
        props: true,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/liquidation/LiquidationSourcePage.vue'),
        meta: {
          useLayouts: true,
        },
      },
      {
        path: 'destination/:accountId',
        name: LiquidationRouteNames.LiquidationDestinationPage,
        props: true,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/liquidation/LiquidationDestinationPage.vue'),
        meta: {
          useLayouts: true,
        },
      },
      {
        path: 'tax-information/:accountId',
        name: LiquidationRouteNames.LiquidationTaxInformationPage,
        props: true,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/liquidation/LiquidationTaxInformationPage.vue'),
        meta: {
          useLayouts: true,
        },
      },
      {
        path: 'confirm/:accountId',
        name: LiquidationRouteNames.LiquidationConfirmPage,
        props: true,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/liquidation/LiquidationConfirmPage.vue'),
        meta: {
          useLayouts: true,
        },
      },
      {
        path: 'success/:accountId',
        name: LiquidationRouteNames.LiquidationSuccessPage,
        props: true,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/liquidation/LiquidationSuccessPage.vue'),
        meta: {
          CMS: true,
          useLayouts: true,
        },
      },
    ],
  },
];
